import React from "react";
import useIsMobile from "hooks/useIsMobile";
import useIsPc from "hooks/useIsPc";
import useIsTablet from "hooks/useIsTablet";

type Props = {
    ita: string;
    eng: string;
};
const ErrorAlert: React.FC<Props> = ({ ita, eng }) => {
    const isMobile = useIsMobile();
    const isPc = useIsPc();
    const isTablet = useIsTablet();

    // Separate style object for the Italian error message when on PC
    const errorItaStyle: React.CSSProperties = isPc
        ? {
            marginRight: "10px" // Adds space to the right of the Italian message
        }
        : {};

    // Conditional styles based on the device
    const errorAnimationStyle: React.CSSProperties = isMobile
        ? {
            width: "500px",
            fontFamily: "Atkinson Hyperlegible, sans-serif",
            color: "white",
            fontSize: "12px",
            animation: "fadeInOut 10s forwards",
            paddingTop: "5px",
        }
        : {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-start", // Ensures items are aligned to the start
            width: "auto",
            fontFamily: "Atkinson Hyperlegible, sans-serif",
            color: "white",
            fontSize: "20px",
            animation: "fadeInOut 10s forwards",
            padding: "5px",
            margin: "5px"
        };

    return (
        <div className={`error-animation flex direction-column align-center z-index-1`} style={errorAnimationStyle}>
            <div className="error-ita" style={errorItaStyle}>{ita}</div>
            <div className="error-eng">{eng}</div>
        </div>
    );
};

export default ErrorAlert;